import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./homepage.css";
import Login from "../login/login";
import Admin from "../login/Admin";
import { retriveToken } from "../../../services/AuthServices";

function Homepage() {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [isStudent, setIsStudent] = useState(true);

  useEffect(() => {
    const retrievedToken = retriveToken();
    const persistToken = localStorage.getItem("persistToken") === "true";
    const sessionToken = sessionStorage.getItem("Token");

    if (retrievedToken && (persistToken || sessionToken)) {
      const userType = localStorage.getItem("type");
      if (userType === "Student") {
        navigate("/user/profile");
      } else {
        navigate("/user/home");
      }
    } else {
      setToken(retrievedToken); // token not useful after navigate, but retained for state use
    }
  }, [navigate]);

  return (
    <> 
      {window.location.hash !== "#/admin" ? (
        <div className="home-page-container">
          <div className="parallax">
            <Login setIsStudent={setIsStudent} />
          </div>
        </div>
      ) : (
        <div className="parallax">
          <Admin />
        </div>
      )}
    </>
  );
}

export default Homepage;
